<div class="order-item">
  <div class="header">
    <div class="t-16 font-weight-bold">{{ order.date_placed | date }}</div>
    <a class="link" [href]="order.invoice_url" target="_blank">{{ "general.invoice" | translate }} #{{ order.reference_number }}</a>
  </div>
  <span class="title">{{ order.title }}</span>
  @if (order.details?.length) {
    <div class="order-data">
      @for (item of order.details; track item) {
        <div>
          @if (productService.productsByProductID[item.product_id]) {
            <myp-order-product (click)="goToProduct(productService.productsByProductID[item.product_id])" [product]="productService.productsByProductID[item.product_id]"></myp-order-product>
          }
          @if (!productService.productsByProductID[item.product_id]) {
            <div class="order-detail-item">
              @if (item.image_url) {
                <img [src]="item.image_url" />
              }
              {{ item.name }}
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="text-right">{{ "general.total" | translate }} {{ order.currency }}: ${{ order.amount }}</div>
</div>
